import SvgClose from '@sats-group/icons/16/close';
import Button from '@sats-group/ui-lib/react/button';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import { Logo } from '../logo/logo';
import { Shortcuts } from '../shortcuts/shortcuts';
import type { Menu as Props } from './menu.types';

export const Menu: React.FC<Props> = ({ close, shortcuts, pages }) => (
  <menu className="menu">
    <header>
      <div role="img" title="SATS Corporate">
        <Logo elementName="div" inline small variant="dark" />
      </div>
    </header>
    <Shortcuts {...shortcuts.primary} />
    <hr className="menu__divider" />
    <nav className="menu__pages">
      {pages.map(entry => (
        <a
          aria-current={entry.current ? 'page' : undefined}
          className="menu__page"
          href={entry.href}
          key={entry.href}
        >
          <div
            dangerouslySetInnerHTML={{ __html: entry.rawIcon }}
            role="presentation"
          />
          <Text>{entry.text}</Text>
        </a>
      ))}
    </nav>
    <hr className="menu__divider menu__divider--bottom" />
    <Shortcuts {...shortcuts.secondary} />
    <div className="menu__close">
      <Button
        {...close}
        leadingIcon={<SvgClose />}
        popoverTargetAction="hide"
        size={Button.sizes.small}
        variant={Button.variants.secondary}
      />
    </div>
  </menu>
);
